import { ITellStoryStoriesRes } from 'src/core/repo/tellStory/type';
import styles from './imageList.module.scss';
import { GoChevronLeft } from 'react-icons/go';
import { Skeleton } from 'antd';

interface Props {
  setStep: (step: number) => void;
  stories?: ITellStoryStoriesRes[];
  isLoading: boolean;
  onSelect : (story : ITellStoryStoriesRes) => void
}

const ImageList = ({ setStep, stories, isLoading , onSelect }: Props) => {
  return (
    <div>
      <div className={styles.description_wrapper}>
        <button onClick={() => setStep(2)} className={styles.back_button}>
          <GoChevronLeft size={22} />
          <p>Back</p>
        </button>
        <h1>Pick a Picture</h1>
        <p>Choose a Picture for Your Child to Tell a Story About</p>
      </div>

      <div className={styles.options}>
        {isLoading ? (
          Array.from({ length: 4 }, (_, idx) => (
            <Skeleton.Image active key={idx} className={styles.option} />
          ))
        ) : !stories ? (
          <div></div>
        ) : (
          stories.map((story) => {
            return (
              <div onClick={() => onSelect(story)} className={styles.option} key={story.StoryBankID}>
                <img src={story.StoryImageURL} alt={story.TrainingTopicTitle} />
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default ImageList;
